// @ts-nocheck
import { createFileRoute } from '@tanstack/react-router';
import CustomerZoneSignaturePage from '@/PageComponents/CustomerZone/CustomerZoneSignature/CustomerZoneSignaturePage';

export default CustomerZoneSignaturePage;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/signature')({ component: CustomerZoneSignaturePage });
